import { useState } from 'react';
import Grain from '@/assets/icons/grain.svg';
import { CluesOverlay, CookiesConsent, Step0, Step1, Step2, Step3, Step4 } from '@/components';

export const App = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepIsChanging, setStepIsChanging] = useState(false);

  const onExitStart = () => setStepIsChanging(true);
  const nextStep = () => {
    setStepIsChanging(false);
    setCurrentStep(prevStep => prevStep + 1);
  };

  return (
    <div className="relative">
      {currentStep === 0 && <Step0 onComplete={nextStep} />}
      {currentStep === 1 && <Step1 onComplete={nextStep} onExitStart={onExitStart} />}
      {currentStep === 2 && <Step2 onComplete={nextStep} onExitStart={onExitStart} />}
      {currentStep === 3 && <Step3 onComplete={nextStep} onExitStart={onExitStart} />}
      {currentStep === 4 && <Step4 />}

      <CookiesConsent />

      {[1, 2, 3].includes(currentStep) && <CluesOverlay currentStep={currentStep} stepIsChanging={stepIsChanging} />}

      <div
        className="absolute inset-0 z-100 pointer-events-none"
        style={{
          backgroundImage: `url("${Grain}")`,
        }}
      />
    </div>
  );
};
